/* eslint-disable */
import shortid from 'shortid';
import moment from 'moment';
const difference = (a, b) => {
    const s = new Set(b);
    return a.filter(x => !s.has(x));
};

const arrayFromObject = (obj) => {
    let res = [];
    for(let key in obj) {
        res.push(obj[key]);
    }
    return res;
};

const debounce = (fn, delay) => {
    var timeoutID = null;
    return function () {
        clearTimeout(timeoutID);
        var args = arguments;
        timeoutID = setTimeout(() => {
            fn.apply(this, args)
        }, delay)
    }
};


// difference([1,2,3], [1,2]) -> [3]

const arrayConcat = (arr, ...args) => arr.concat(...args);
// arrayConcat([1], 2, [3], [[4]]) -> [1,2,3,[4]]

const intersection = (a, b) => {
    const s = new Set(b);
    return a.filter(x => s.has(x));
};
// intersection([1,2,3], [4,3,2]) -> [2,3]

const escapeHTML = str =>
    str.replace(
        /[&<>'"]/g,
        tag =>
            ({
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                "'": '&#39;',
                '"': '&quot;'
            }[tag] || tag)
    );

const unescapeHTML = str =>
    str.replace(
        /&amp;|&lt;|&gt;|&#39;|&quot;/g,
        tag =>
            ({
                '&amp;': '&',
                '&lt;': '<',
                '&gt;': '>',
                '&#39;': "'",
                '&quot;': '"'
            }[tag] || tag)
    );

const isArrayLike = val => {
    try {
        return [...val], true;
    } catch (e) {
        return false;
    }
};

const isEmpty = val => val == null || !(Object.keys(val) || val).length;

const isNil = val => val === undefined || val === null;

const isNumber = val => typeof val === 'number';

const isNull = val => val === null;

const isObject = obj => obj === Object(obj);

const isObjectLike = val => val !== null && typeof val === 'object';

const isString = val => typeof val === 'string';

const isUndefined = val => val === undefined;

const deepClone = obj => {
    let clone = Object.assign({}, obj);
    Object.keys(clone).forEach(
        key => (clone[key] = typeof obj[key] === 'object' ? deepClone(obj[key]) : obj[key])
    );
    return clone;
};

const isValidJSON = obj => {
    try {
        JSON.parse(obj);
        return true;
    } catch (e) {
        return false;
    }
};

const average = arr => arr.reduce((acc, val) => acc + val, 0) / arr.length;
// average([1,2,3]) -> 2

const flatten = arr => arr.reduce((a, v) => a.concat(v), []);
// flatten([1,[2],3,4]) -> [1,2,3,4]

const flattenDeep = (arr, k) => {
    if (!arr.reduce) {
        return arr;
    }
    return arr.reduce((acc, val) => Array.isArray(val[k]) ? acc.concat(flattenDeep(val, k)) : acc.concat(val), []);
}

const chunk = (arr, size) =>
    Array.from({length: Math.ceil(arr.length / size)}, (v, i) => arr.slice(i * size, i * size + size));
// chunk([1,2,3,4,5], 2) -> [[1,2],[3,4],5]

const arrayMax = arr => Math.max(...arr);
// arrayMax([10, 1, 5]) -> 10

const arrayMin = arr => Math.min(...arr);
// arrayMin([10, 1, 5]) -> 1

const groupBy = (arr, func) =>
    arr.map(typeof func === 'function' ? func : val => val[func])
    .reduce((acc, val, i) => {
        acc[val] = (acc[val] || []).concat(arr[i]);
        return acc;
    }, {});
// groupBy([6.1, 4.2, 6.3], Math.floor) -> {4: [4.2], 6: [6.1, 6.3]}
// groupBy(['one', 'two', 'three'], 'length') -> {3: ['one', 'two'], 5: ['three']}

const pickValuesFromArray = (obj, arr, key) => {
    return arr.reduce((acc, curr) => (curr in obj && (acc[curr] = key ? obj[curr][key] : obj[curr]), acc), {});
};

const compact = (arr) => arr.filter(v => v);
// compact([0, 1, false, 2, '', 3, 'a', 'e'*23, NaN, 's', 34]) -> [ 1, 2, 3, 'a', 's', 34 ]

const domBottomVisible = () => {
    document.documentElement.clientHeight + window.scrollY >= document.documentElement.scrollHeight || document.documentElement.clientHeight;
};

const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
    const { top, left, bottom, right } = el.getBoundingClientRect();
    return partiallyVisible
        ? ((top > 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) &&
        ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
        : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
};

const scrollToTop = () => {
    const c = document.documentElement.scrollTop || document.body.scrollTop;
    if (c > 0) {
        window.requestAnimationFrame(scrollToTop);
        window.scrollTo(0, c - c / 8);
    }
};

const chainAsync = fns => {
    let curr = 0;
    const next = () => {
        fns[curr++](next);
        next();
    };
};
const pipePromises = (...funcs) => arg => funcs.reduce((acc, func) => func(acc), arg);

// series([() => delay(1000), () => delay(2000)]) -> executes each promise sequentially, taking a total of 3 seconds to complete
const seriesOfPromises = ps => ps.reduce((p, next) => p.then(next), Promise.resolve());

const distanceBetweenPoints = (x0, y0, x1, y1) => Math.hypot(x1 - x0, y1 - y0);
// distance(1,1, 2,3) -> 2.23606797749979

const isEvenNumber = num => num % 2 === 0;

const isDivisible = (dividend, divisor) => dividend % divisor === 0;

const roundNumberToXdigits = (n, decimals=0) => Number(`${Math.round(`${n}e${decimals}`)}e-${decimals}`);

const shallowClone = obj => ({ ...obj });
/*
const a = { x: true, y: 1 };
const b = shallowClone(a);
a === b -> false
*/

const escapeRegExp = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const isBoolean = val => typeof val === 'boolean';

const getNestedProperty = (obj, path) => path.reduce((obj, child) => obj && obj[child] ? obj[child] : null, obj);

const getUrlParameters = url =>
    url.match(/([^?=&]+)(=([^&]*))/g).reduce(
        (a, v) => (a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1), a), {}
    );

const uuid = () =>
    ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );

const validateNumber = n => !isNaN(parseFloat(n)) && isFinite(n) && Number(n) === n;

const valueOrDefault = (value, d) => value || d;
// valueOrDefault(NaN, 30) -> 30

const noop = () => {};

const getFormatName = (formatList, options) => {
    let index, joinNames;
    if(options) {
        index = options.index;
        joinNames = options.joinNames;
    }
    if(!formatList) {
        return '';
    }
    if(isArray(formatList)) {
        if(joinNames) {
            return formatList.map(format => format.displayString ? format.displayString : format.id).join(' | ');
        }
        if(validateNumber(index)) {
            return formatList[index].displayString || formatList[index].id;
        } else {
            return formatList[0].displayString || formatList[0].id;
        }
    } else if (typeof formatList === 'object') {
        return formatList.displayString;
    }
    return formatList;
};
const onlyUniqueItems = (value, index, self) => self.indexOf(value) === index;

const exportData = ({data, fileName = 'export', format = 'json', stringify = true}) => {
    return new Promise((resolve, reject) => {
        if(!data) {
            reject(new Error('invalid or empty data'));
        }
        let dataStr = `data:text/${format !== 'js' ? 'json' : 'javascript'};charset=utf-8,` + encodeURIComponent(stringify ? JSON.stringify(data) : data);
        let downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute('href', dataStr);
        downloadAnchorNode.setAttribute('download', `${fileName}.${format}`);
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
        resolve({status: 'success'});
    });
};
const isArray = val => !!val && Array.isArray(val);

const timeTaken = callback => {
    console.time('timeTaken');
    const r = callback();
    console.timeEnd('timeTaken');
    return r;
};

/**
 * @function createPromiseArray
 * @param {Function} func - function to add
 * @param {Array} items - items to iterate over
 * @param {String} itemKey - object key to use
 * @returns {Array} returns an array of promises
 * */
const createPromiseArray = (func, items, itemKey) => {
    let promises = [];
    items.forEach(item => {
        promises.push(func(itemKey ? item[itemKey] : item));
    });
    return promises;
};

/**
 * @function toResultObject
 * @param {Promise} promise - promise to convert
 * @returns {Object} - a converted Promise
 * */
const toResultObject = (promise) => promise
    .then(result => ({ success: true, result }))
    .catch(err => ({ success: false, err }));
/**
 * @function resolvePromises
 * @param {Array} promises - array of promises
 * @returns {Promise} - result of a Promise batch
 * */
const resolvePromises = (promises) => Promise.all(promises.map(toResultObject))
    .then(values => filterPromiseErrors(values.map(({result}) => result)));

/**
 * @function filterPromiseErrors
 * @param {Promise} promiseRes - promise response to be filtered from errors and normalized
 * @returns {Promise} - a normalized promise response, filtered from failed promises
 * */
const filterPromiseErrors = (promiseRes) => promiseRes.filter(res => res && !res.err).map((res) => res.data || res);


/**
 * @function isPrimitive
 * @description Checks if passed value is primitive or not
 * @param {Any} val - val to be checked
 * @returns {Boolean} returns a boolean determining if the passed value is primitive or not.
 * */
const isPrimitive = val => !['object', 'function'].includes(typeof val) || val === null;
/**
 * @function getNestedKeyPaths
 * @description This function deep searches objects and arrays in order to find requested search key or value
 * @param {Object} objectToSearch - Source object to search paths / values in
 * @param {String} searchedKey - object key to be searched
 * @param {Boolean} searchValue - Flag indicating that it should also return values that match the searchedKey
 * @param {Array} arr - empty array, defaults to empty array for initial setup used for single execution
 * @param {Array} resultArray - empty array, defaults to empty array for initial setup and is then passed in recursion
 * @returns {Object} - returns an object with a found flag and a resultArray that is an array of object containing
 * paths to searched key and it's value
 * */
const getNestedKeyPaths = (objectToSearch, searchedKey, searchValue = false, arr = [], resultArray = [] ) => {
    let found = false;
    if(!objectToSearch || !searchedKey || typeof objectToSearch !== 'object') {
        return {found: false, resultArray: resultArray};
    }

    if(objectToSearch.hasOwnProperty(searchedKey)) {
        resultArray.push({path: [...arr, searchedKey], searchedKey: objectToSearch[searchedKey]});
        found = true
    }

    for(let key in objectToSearch) {
        if(searchValue && objectToSearch[key] === searchedKey) {
            resultArray.push({path: [...arr, key], searchedValue: objectToSearch[key]});
            found = true
        } else {
            let result = getNestedKeyPaths(objectToSearch[key], searchedKey, searchValue, [...arr, key], resultArray);
            if(result.found) {
                resultArray = result.resultArray;
                found = true;
            }
        }

    }

    return {found, resultArray};
};

const utils = {
    getNestedKeyPaths,
    isPrimitive,
    pickValuesFromArray,
    domBottomVisible,
    elementIsVisibleInViewport,
    scrollToTop,
    chainAsync,
    createPromiseArray,
    pipePromises,
    seriesOfPromises,
    isEvenNumber,
    compact,
    isDivisible,
    noop,
    onlyUniqueItems,
    distanceBetweenPoints,
    roundNumberToXdigits,
    shallowClone,
    escapeRegExp,
    toResultObject,
    resolvePromises,
    deepClone,
    isArray,
    filterPromiseErrors,
    arrayFromObject,
    isBoolean,
    timeTaken,
    getUrlParameters,
    uuid,
    validateNumber,
    valueOrDefault,
    difference,
    debounce,
    arrayConcat,
    intersection,
    average,
    flatten,
    flattenDeep,
    chunk,
    arrayMin,
    arrayMax,
    groupBy,
    getNestedProperty,
    isEmpty,
    isArrayLike,
    isNil,
    isNumber,
    isNull,
    isObject,
    isObjectLike,
    isString,
    isUndefined,
    isValidJSON,
    shortid,
    escapeHTML,
    unescapeHTML,
    moment,
    getFormatName,
    exportData
};

const UtilsPlugin = {
    install: (Vue) => {
        Vue.prototype.$utils = {
            ...utils
        };
    }
};

export {UtilsPlugin as UtilsPlugin, utils as utils};
